export const MINIMAL_INVOICE_NUMBER = 1
